/*
 * Copyright (c) 2025 BarD Software s.r.o.
 * Author: Dmitry Barashev (dbarashev@ganttproject.biz)
 */

import { createApp } from 'vue';
import Signin from './Signin.vue';

const app = createApp(Signin);
app.mount('#app');
